/*
 * Clamp and convert a decimal (0 - 1) to a percentage between 0 and 100
 * @param {number | null} val - The number to clamp
 */
export const clamp = (val?: number | null): number => {
    return val ? Math.min(Math.max(0, Math.floor(val * 100)), 100) : 0;
};
